import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const editorialTeamMembershipApi = generateNomenApi(`/editorial-team/editorial-team-membership`);

export const editorialTeamMembershipOptions = generateNomenOptions(
  'editorialTeam-membership',
  editorialTeamMembershipApi,
);
